import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';
import { templateViews } from './widgets.js';

let widgetProps = {};
for (var section of templateViews) {
    const { sections } = section;
    widgetProps[section.handle] = { sections };
}

export default {
    handle: 'tomYouth',
    label: 'TOM2.0 Youth',
    builderInitialValues,
    builder: Builder,
    player: Player,
    widgetProps,
};
